import { Keyword } from '../../../../api/core'
import { InternalFeatureMapEntry } from '../../../api/features'
import { ContentLanguageTranslation } from '../../../types/InternalAnalystComment'

export enum KeywordPriority {
  Normal = 0,
  High = 1,
}

export type InternalKeyword = Keyword & {
  type: string
  names: ContentLanguageTranslation | null
  translations: null
  createdAt?: number
  modifiedAt?: number
  createdBy?: string | null
  modifiedBy?: string | null
}

export type KeywordMutation = Omit<InternalKeyword, 'id'> & { id?: string }

export type KeywordFeature = Pick<InternalFeatureMapEntry, 'legacyId' | 'name'>
